module.exports = __webpack_public_path__ + "img/loby-restaurant.1bab91f1.jpg";